"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoProgressReport = void 0;
const rxjs_1 = require("rxjs");
class NoProgressReport {
    constructor() {
    }
    get steps$() { return rxjs_1.EMPTY; }
    get retries$() { return rxjs_1.EMPTY; }
    retry(index, count) {
    }
    step(index, total) {
    }
}
exports.NoProgressReport = NoProgressReport;
NoProgressReport.instance = new NoProgressReport();
//# sourceMappingURL=no-progress-report.js.map